import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_ACCOUNT_NAME = gql`
  query fetchAccount($id: SafeString!) {
    fetchAccount(input: { accountId: $id }) {
      account { type translatedNickName { ${TRANSLATED_STRING_FIELDS} } }
    }
  }
`;
